<script setup lang="ts">
import FieldHealthAndSafety from "@/features/experience-shared/components/FieldHealthAndSafety.vue";
import { RevisionFormProps } from "../types/forms";
import NovaCheckboxGroup from "@/ui-kit/NovaCheckboxGroup/NovaCheckboxGroup.vue";
import { useAdditionalServicesMasterdata } from "@/features/masterdata/composables";
const props = defineProps<RevisionFormProps>();

const { additionalServices } = useAdditionalServicesMasterdata();
const additionalServicesOptions = computed(() =>
  additionalServices.value.map((i) => ({
    label: i.name,
    value: i.code,
  }))
);

const { values } = toRefs(props);
</script>

<template>
  <DocumentFormSection id="animal_welfare" data-testid="revision-distribution-tags-animal-welfare">
    <NovaCheckboxGroup
      :model-value="values?.animalWelfareTags"
      :options="additionalServicesOptions"
      :readonly="true"
      :columns="1"
    />
  </DocumentFormSection>

  <DocumentFormSection id="health_and_safety" data-testid="revision-distribution-tags-health-and-safety">
    <FieldHealthAndSafety
      :model-value="values?.healthAndSafetyTags || []"
      :options="additionalServicesOptions"
      :readonly="true"
    />
  </DocumentFormSection>

  <DocumentFormSection id="other_tags" data-testid="revision-distribution-tags-other-tags">
    <NovaCheckboxGroup
      :model-value="values?.otherTags"
      :options="additionalServicesOptions"
      :readonly="true"
      :columns="1"
    />
  </DocumentFormSection>
</template>
